import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Navigation } from './Erreur.navigation';
import { Erreur } from './Erreur';
import { HeadingProvider } from '../../context';
import { Headings } from '../../styles';
import {
    hideLoading,
    sendEvent,
    EVENT_CATEGORIES,
    EVENT_ACTIONS,
    EVENT_LABELS
} from './../../features';
import { prepareDiagnosticData, useRapportApi } from '../../hooks';
import { AxiosError } from 'axios';
interface ErreurProps {
    codeErreur: number;
    axiosError?: AxiosError<any>;
}

export enum CODE_ERREUR_TECHNIQUE_RHN {
    ERREUR_TECHNIQUE = 'RSET9000'
}

const headingMapping = {
    h1: Headings.h3
};

export const ErreurConnected: React.FC<ErreurProps> = ({
    codeErreur,
    axiosError
}) => {
    const dispatch = useDispatch();

    // Store
    const renouvellementData = useSelector(
        (state: any) => state.renouvellement.renouvellementData
    );
    const sessionData = useSelector(
        (state: any) => state.renouvellement.sessionData
    );
    const flowData = useSelector((state: any) => state.renouvellement.flowData);

    useEffect(() => {
        dispatch(hideLoading());

        dispatch(
            sendEvent({
                category: EVENT_CATEGORIES.FORMULAIRE,
                action: EVENT_ACTIONS.ERREUR_TECHNIQUE,
                label: EVENT_LABELS.FRM,
                messageErreur: codeErreur
            })
        );

        //Try to send report data
        const diagnosticData = prepareDiagnosticData(
            sessionData,
            renouvellementData,
            flowData,
            axiosError?.config?.url,
            axiosError?.response?.data?.errors,
            'Technique',
            'Erreur technique'
        );
        useRapportApi(diagnosticData);
    }, []);

    return (
        <HeadingProvider value={headingMapping}>
            <Erreur />
            <Navigation />
        </HeadingProvider>
    );
};
